import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgValuecodeAlt = function SvgValuecodeAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.93 2.531h-2.016c0 .844-.656 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5H4.024A3.981 3.981 0 00.038 6.516v10.968a3.981 3.981 0 003.984 3.985h10.938c0-.844.656-1.5 1.5-1.5s1.5.656 1.5 1.5h2.016a3.981 3.981 0 003.984-3.985V6.516c0-2.204-1.828-3.985-4.031-3.985zm2.015 14.906c0 1.079-.89 2.016-2.015 2.016h-.61a3.506 3.506 0 00-2.86-1.5c-1.17 0-2.202.61-2.858 1.5H4.023c-1.078 0-2.015-.89-2.015-2.015V6.515c0-1.079.89-2.016 2.015-2.016h9.579c.609.89 1.687 1.5 2.859 1.5s2.25-.61 2.86-1.5h.609c1.078 0 2.015.89 2.015 2.016v10.921z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M9.68 8.297a1.02 1.02 0 00-1.407 0 1.02 1.02 0 000 1.406L9.54 10.97H4.992a.99.99 0 00-.984.984c0 .516.469.985.984.985H9.54l-1.266 1.265a1.02 1.02 0 000 1.406c.188.188.47.282.704.282.234 0 .515-.094.703-.282l3-3a1.02 1.02 0 000-1.406l-3-2.906zM16.46 16.453a1.5 1.5 0 10.001-3 1.5 1.5 0 000 3zM16.46 10.5a1.5 1.5 0 10.001-3 1.5 1.5 0 000 3z"
  }));
};

export default SvgValuecodeAlt;